import { render, staticRenderFns } from "./CustomTargetingSelect.vue?vue&type=template&id=6d8fa06f&"
import script from "./CustomTargetingSelect.vue?vue&type=script&lang=ts&"
export * from "./CustomTargetingSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports